import React, { useState, useEffect, useRef } from "react";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import "./BadgeMaster.css";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import { APICall } from "../../../helpers/API/APICalls";
import {
  getBadgeMasterDataById,
  insertUpdateBadgeMaster,
} from "../../../helpers/API/APIEndPoints";
import moment from "moment";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import { useHistory, useParams } from "react-router-dom";
import {
  saveRecordMsg,
  updateRecordMsg,
} from "../../../helpers/Constants/Constants";
import { Button, Card, Form, Image, InputGroup } from "react-bootstrap";
import { del } from "../../../constants/Images";
import { Modal } from "@material-ui/core";
import ButtonForm from "../../../ReusableComponents/ButtonForm/ButtonForm";
import CreateKnowledgeService from "../../../services/CreateKnowledgeService";
import { downloadBlob } from "../../../services/CommonService";
import SubmitButton from "../../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import ResetButton from "../../../ReusableComponents/Buttons/ResetButton/ResetButton";
import CancelButton from "../../../ReusableComponents/Buttons/CancelButton/CancelButton";
import Decrypt2 from "../../../helpers/Cryptography/CryptoJS";
import FormLabel from "../../../ReusableComponents/FormLabel/FormLabel";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import DeleteDialogueBox from "../../../ReusableComponents/DeleteDialogueBox/DeleteDialogueBox";
import CommonConstants from "../../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../../helpers/Utils/Utils";

const BadgeMasterEdit = (props) => {
  let history = useHistory();
  // const { id: badgeId } = useParams();
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editModeIsActive, setEditModeIsActive] = useState(true);
  const [editModeDisableButton, setEditModeDisableButton] = useState(true);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [fileToBeDeleted, setFileToBeDeleted] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [Id, setId] = useState(0);

  const inputFileRef = useRef();
  const [files, setFiles] = useState([]);
  const [badge, setBadge] = useState("");
  const [min, setMin] = useState();
  const [max, setMax] = useState();
  const [isActive, setIsActive] = useState(true);
  let formErrorObj = {};
  let state_id = 0;

  const [allowedFileTypes, setAllowedFileTypes] = useState("");
  useEffect(() => {
    const allowedImagesFileTypesLS = getFromEncLocalStorage(
      "ImageFilesValidationExtension"
    );
    if (allowedImagesFileTypesLS) {
      setAllowedFileTypes(
        [...allowedImagesFileTypesLS.split(",")]
          .map((aift) => `.${aift}`)
          .join(",")
      );
    }
  }, []);

  useEffect(() => {
    (async () => {
      state_id = await Decrypt2(getFromEncLocalStorage("tokennumber")); //history?.location?.state?.id;
      if (state_id !== 0 || state_id != "0") {
        getBadgeMasterDataByIdApiCall(state_id);
      }
    })();
  }, []);

  const getBadgeMasterDataByIdApiCall = async (id) => {
    setLoading(true);
    const data = await APICall(getBadgeMasterDataById, { id: id }, "POST");

    if (data.message === "Ok") {
      if (data && data.data && data.data[0][0] && data.data[0][0].id) {
        setId(data.data[0][0].id);
        setBadge(data.data[0][0].badges);
        setMin(data.data[0][0].PointsMin);
        setMax(data.data[0][0].PointsMax);
        setIsActive(data.data[0][0].IsActive == 1 ? true : false);
        setEditModeIsActive(false);
        setEditModeDisableButton(false);
        let dataArr = data.data[0];
        let dataObj = dataArr[0];

        let filesTmp = [];
        // setFiles(filesTmp);
        for (let index = 0; index < dataArr?.length; index++) {
          dataObj = dataArr?.[index];

          if (dataObj.badge_picture != null) {
            const fullResImgUrl = await downloadBlob(dataObj?.badge_picture);
            const azureFileName = new URL(dataObj?.badge_picture)?.pathname
              ?.split("/")
              ?.pop();
            filesTmp.push({
              localUrl: fullResImgUrl,
              blob: null,
              id: `img_${index}`,
              name: "",
              size: null,
              type: "",
              globalUrl: dataObj.badge_picture,
              azureFileName: azureFileName,
              exists: true,
            });
          }
        }
        setFiles(filesTmp);
      }
      setLoading(false);
    } else {
      notify(1, data.message);
      setLoading(false);
    }
  };

  const onClickFunction = async (event, action) => {
    if (action === "Submit") {
      await checkValidations();
      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x === undefined
      );
      if (isEmpty) {
        setLoading(true);

        let filesTmp = [...files];
        for (let index = 0; index < filesTmp?.length; index++) {
          const file = filesTmp?.[index];
          if (!file?.globalUrl) {
            let resp = await saveImage(file.blob);
            let imgUrl = resp?.result?.[0];
            if (imgUrl) {
              file.globalUrl = imgUrl;
            }
          }
        }
        setFiles(filesTmp);

        let requestParams = {
          Id: Id,
          Badge: badge.replace(/\s+/g, " ").trim(),
          Min: min,
          Max: max,
          isActive: isActive,
          attachments: filesTmp,
          createdDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
          userId: getFromEncLocalStorage("userId"), //UserId
        };
        console.log(requestParams);

        const res = await APICall(
          insertUpdateBadgeMaster,
          requestParams,
          "POST"
        );
        if (res.message === "Ok") {
          if (res && res.data !== 0) {
            if (Id === 0) {
              notify(0, saveRecordMsg);
            } else if (Id > 0) {
              notify(0, updateRecordMsg);
            }
            history.push({ pathname: "/badge-master" });
          }
          setLoading(false);
        } else {
          notify(1, res.message);
          setLoading(false);
        }
        setLoading(false);
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      history.push({ pathname: "/badge-master" });
    }
  };

  const resetFunction = () => {
    setFormErrors({});
    setBadge("");
    setMin("");
    setMax("");
    setFiles([]);
    formErrorObj = {};
  };

  const handleNumericEvent = async (event, field) => {
    var error = undefined;
    let tempName = event.target.value;
    var setError = "";
    if (field === "min") {
      await setMin(tempName);
      setError = "Min";
    }
    if (field === "max") {
      await setMax(tempName);
      setError = "Max";
    }

    if (
      tempName == undefined ||
      tempName == null ||
      /^[0-9]\d*/.test(tempName) == ""
    ) {
      error = setError + " Value Cannot Empty";
    }

    setFormErrors((preState) => ({
      ...preState,
      [setError.replaceAll(" ", "") + "_isEmpty"]: error,
    }));
  };

  const handleTextEvent = async (event, field) => {
    var error = undefined;
    let tempName = event.target.value;
    var setError = "";
    if (field === "badge") {
      setBadge(tempName);
      setError = "Badge";
    }

    if (tempName == undefined || tempName == null || tempName.trim() == "") {
      error = setError + " Cannot Be Empty";
    }

    setFormErrors((preState) => ({
      ...preState,
      [setError.replaceAll(" ", "") + "_isEmpty"]: error,
    }));
  };

  const checkValidations = async () => {
    var objError = {};
    var setError = "";

    if (badge == undefined || badge == null || badge.trim() == "") {
      setError = "Badge";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Cannot Be Empty";
    } else if (badge.replace(/\s+/g, " ").trim().length >= 50) {
      setError = "Badge";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Is Longer Than The 50 Character";
    }

    if (files.length <= 0) {
      objError["File_isEmpty"] = "Please Select Badge Image";
    }

    if (min == undefined || min == null || /^[0-9]\d*/.test(min) == "") {
      objError["Min_isEmpty"] = "Min Value Cannot Empty";
    }
    if (max == undefined || max == null || /^[0-9]\d*/.test(max) == "") {
      objError["Max_isEmpty"] = "Max Value Cannot Empty";
    }

    if (parseInt(min) > parseInt(max)) {
      objError["MaxMin_isEmpty"] =
        "Number Should Be Greater Than Or Equal To Min";
    }
    // image icon pending

    formErrorObj = objError;
    await setFormErrors(objError);
  };

  const onFileChange = (e) => {
    if (
      [...e?.target?.files].filter((f) => !f.type.startsWith("image")).length >
      0
    ) {
      notify(1, "Only images is allowed!");
      return;
    }

    // #region check file extension with config value
    const allowedFileTypesArr = [...allowedFileTypes?.split(",")];
    if (allowedFileTypesArr) {
      let isExtensionAllowed = true;
      let filesToCheck = [...e?.target?.files];
      for (let index = 0; index < filesToCheck.length; index++) {
        const fileToCheck = filesToCheck[index];
        isExtensionAllowed = allowedFileTypesArr.some((ext) =>
          fileToCheck?.name?.endsWith(ext)
        );
        if (!isExtensionAllowed) break;
      }
      if (!isExtensionAllowed) {
        notify(1, `Only ${allowedFileTypesArr?.join(", ")} files are allowed!`);
        return;
      }
    }
    // #endregion

    let filesTmp = [];
    for (let index = 0; index < e?.target?.files?.length; index++) {
      const file = e?.target?.files?.[index];
      console.log(e?.target?.files);
      if (file) {
        filesTmp.push({
          localUrl: URL.createObjectURL(file),
          blob: file,
          id: `img_${index}`,
          name: file.name,
          size: file.size,
          type: file.type,
        });
      }
    }
    setFiles(filesTmp);

    setFormErrors((preState) => ({
      ...preState,
      ["File_isEmpty"]: "",
    }));
  };

  const handleBtnClick = (e) => {
    inputFileRef.current.click();
  };

  const deleteImage = () => {
    setFiles([]);
    setShowDeleteConfirmationModal(false);
  };

  const saveImage = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    let resp = await CreateKnowledgeService.fileUpload(formData, "gallery");

    return resp;
  };

  return (
    <>
      <Main active={"badge_master"} removeContainer={true}>
        <Loadspinner filename="BadgeMasterEdit.js" isLoading={loading} isMiddle="false" />
        <div className="eventGalleryEdit">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ paddingLeft: "5px" }}>Master</h4>
              </div>
              <div className="clearfix"></div>
              <div
                className="d-flex align-items-center justify-space-between"
                style={{
                  background: "#e61636",
                  padding: "10px 20px 10px 10px",
                  color: "white",
                  width: "100%",
                }}
              >
                <div className="col-lg-8">Badge</div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Badge Title</label> */}
                      <FormLabel value="Badge Title" />
                      <sup>*</sup>
                      <InputForm
                        className="form-control form-control-sm"
                        placeholder={"Badge Title"}
                        isDisabled={editMode ? true : false}
                        textArea={false}
                        value={badge}
                        onChange={(e) => handleTextEvent(e, "badge")}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["Badge_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["Badge_isEmpty"]} />
                    </div>
                  </div>

                  <div className="col-lg-8 col-sm-8 col-xs-8 ">
                    <div className="row">
                      <div className="col-lg-6 col-sm-6 col-xs-6 ">
                        {/* <label className="col-form-label">Point Range</label> */}
                        <FormLabel value="Point Range" />
                        <sup>*</sup>
                        <div className="col-lg-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-lg-2 col-sm-2 col-xs-2">
                              Min<sup>*</sup>
                            </div>
                            <div className="col-lg-9 col-sm-9 col-xs-9">
                              <div className="form-group">
                                <InputForm
                                  className="form-control form-control-sm"
                                  placeholder={"Min"}
                                  isDisabled={editMode ? true : false}
                                  textArea={false}
                                  type="number"
                                  value={min}
                                  onChange={(e) => handleNumericEvent(e, "min")}
                                />
                                {/* <p style={{ color: "red" }}>
                                  {formErrors["Min_isEmpty"]}
                                </p> */}
                                <ErrorLabel value={formErrors["Min_isEmpty"]} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <span>-</span> */}
                      <div className="col-lg-6 col-sm-6 col-xs-6 ">
                        <div style={{ paddingTop: "35px" }}></div>
                        <div className="col-lg-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-lg-2 col-sm-2 col-xs-2">
                              Max<sup>*</sup>
                            </div>
                            <div className="col-lg-9 col-sm-9 col-xs-9">
                              <div className="form-group">
                                <InputForm
                                  className="form-control form-control-sm"
                                  placeholder={"Max"}
                                  type="number"
                                  isDisabled={editMode ? true : false}
                                  textArea={false}
                                  value={max}
                                  onChange={(e) => handleNumericEvent(e, "max")}
                                />
                                {/* <p style={{ color: "red" }}>
                            {formErrors["Max_isEmpty"]}
                          </p> */}
                                <ErrorLabel value={formErrors["Max_isEmpty"]} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <p style={{ color: "red" }}>
                      {formErrors["MaxMin_isEmpty"]}
                    </p> */}
                    <ErrorLabel value={formErrors["MaxMin_isEmpty"]} />
                  </div>
                </div>

                <div className="col-lg-12 col-md-12 mt-3">
                  <div className="row">
                    <div
                      className="col-lg-4 col-sm-4 col-xs-4"
                      style={{ position: "relative" }}
                    >
                      {/* <label className="col-form-label">Badge Image</label> */}
                      <FormLabel value="Badge Image" />
                      <sup className="required">*</sup>
                      <InputGroup className="mb-1">
                        <InputForm
                          className="form-control form-control-sm fileInputStyle"
                          placeholder={"images"}
                          isDisabled={false}
                          textArea={false}
                          onClick={handleBtnClick}
                          readOnly
                        />
                        <ButtonForm
                          variant="secondary"
                          id="button-addon2"
                          value="Browse"
                          onClick={handleBtnClick}
                        />
                      </InputGroup>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        id="btn_event_gallery_master_file_input"
                        ref={inputFileRef}
                        onChange={onFileChange}
                        accept={`${allowedFileTypes}`}
                        autoComplete={CommonConstants.autoCompleteInput}
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          position: "absolute",
                          right: "15px",
                        }}
                      >
                        Note: Image should be of 50x50 pixels
                      </span>
                      {/* <p style={{ color: "red" }}>
                        {formErrors["File_isEmpty"]}
                      </p> */}

                      <p style={{ position: "absolute", top: "86px" }}>
                        <ErrorLabel value={formErrors["File_isEmpty"]} />
                      </p>
                    </div>
                    <div className="col-lg-4 col-sm-4 col-xs-4">
                      <div className="form-group">
                        {/* <label className="col-form-label">Active Status</label> */}
                        <FormLabel value="Active Status" />
                        <div className="custom-checkbox">
                          <input
                            disabled={editModeIsActive ? true : false}
                            type="checkbox"
                            onChange={(e) => setIsActive(e.target.checked)}
                            name="isActive"
                            checked={isActive}
                            className="isActive"
                            autoComplete={CommonConstants.autoCompleteInput}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {files?.map((file, fIdx) => {
                      return (
                        <Card
                          key={`img${fIdx}`}
                          className="col-lg-2 col-sm-2 col-xs-2 imgCard" style={{ top: '15px' }}
                        >
                          <Card.Img
                            variant="top"
                            src={file?.localUrl}
                            className="gridImage"
                          />
                          <Card.Body className="imgCardBody">
                            <div className="row my-1">
                              <div className="col-lg-9 col-sm-9 col-xs-9 text-center">
                                <Card.Text>{file?.name || file?.azureFileName}</Card.Text>
                              </div>
                              <div className="col-lg-2 col-sm-2 col-xs-2">
                                <Button variant="outline-light" size="sm">
                                  <Image
                                    src={del}
                                    className="delBtn"
                                    onClick={() => {
                                      setFileToBeDeleted(file);
                                      setShowDeleteConfirmationModal(true);
                                    }}
                                  />
                                </Button>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-11 col-md-11" style={{ width: "97%" }}>
                    <div className="float-right">
                      <SubmitButton
                        onClick={(e) => onClickFunction(e, "Submit")}
                      />
                      {editModeDisableButton && (
                        <ResetButton
                          onClick={(e) => onClickFunction(e, "Reset")}
                        />
                      )}
                      <CancelButton
                        onClick={(e) => onClickFunction(e, "Cancel")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Modal
          open={showDeleteConfirmationModal}
          onClose={() => setShowDeleteConfirmationModal(false)}
          className="modal-dialog modal-dialog-centered"
        >
          <div className="modal-content logout-modal">
            <div className="modal-body">
              Are you sure you want to delete this image?
            </div>
            <div className="display-row justify-space-evenly">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => {
                  setFileToBeDeleted(null);
                  setShowDeleteConfirmationModal(false);
                }}
              >
                Cancel
              </button>
             
              <button
                className="btn btn-danger"
                type="button"
                onClick={() => deleteImage()}
              >
                Delete
              </button>
             
            </div>
          </div>
        </Modal> */}
        <DeleteDialogueBox
          open={showDeleteConfirmationModal}
          close={() => setShowDeleteConfirmationModal(false)}
          cancel={() => {
            setFileToBeDeleted(null);
            setShowDeleteConfirmationModal(false);
          }}
          deleteImage={() => deleteImage()}
        />
      </Main>
    </>
  );
};

export default BadgeMasterEdit;
